import * as React from 'react'

import ApiAdditionalFields from './Api'
import IOSAndroidPNSDKAdditionalFields from './iOSAndroidPNSDK'
import WebAdditionalFields from './Web'

interface Props {
  selected: string | undefined
}

const AdditionalFields: React.FC<Props> = ({selected}) => {
  const isIOSAndroidPNSDK = (): boolean => {
    return (
      selected === 'ios' ||
      selected === 'android' ||
      selected === 'push_notification' ||
      selected === 'sdk'
    )
  }

  return (
    <>
      {selected === 'web' && <WebAdditionalFields />}
      {selected === 'api' && <ApiAdditionalFields />}
      {isIOSAndroidPNSDK() && <IOSAndroidPNSDKAdditionalFields />}
    </>
  )
}

export default AdditionalFields
